import React, { useRef } from 'react';

import classNames from 'classnames';

import DetailsPopup from '../DetailsPopup/DetailsPopup';

import './StudentGradeCell.scoped.scss';
import getGradeName from '../helper';

interface Props {
  id: string;
  gradeItem: any;
  popoverOpened: string;

  setPopoverOpened: React.Dispatch<React.SetStateAction<string>>;
}

const StudentGradeCell: React.FC<Props> = ({ id, gradeItem, popoverOpened, setPopoverOpened }) => {
  const rootNode = useRef(null);
  const detailsOpened = id === popoverOpened;

  const handleClick = () => {
    setPopoverOpened(id);
  };

  return (
    <td
      className={classNames({
        'grades-table-grade-cell': true,
        details: detailsOpened,
        'has-grade': gradeItem && gradeItem.mark,
      })}
      onClick={handleClick}
    >
      <div
        ref={rootNode}
        className={classNames({
          content: true,
          'no-grade': !gradeItem || !gradeItem.mark,
        })}
      >
        {/* {gradeItem?.mark?.name || '-'} */}
        &nbsp; &nbsp;
        {gradeItem?.mark?.name ? getGradeName(gradeItem?.mark?.name) : '-'}
        &nbsp; &nbsp;
      </div>

      {detailsOpened && (
        <DetailsPopup
          gradeItem={gradeItem}
          gradeName={gradeItem?.mark?.name || '-'}
          onClose={() => {
            setPopoverOpened('');
          }}
          rootNode={rootNode}
        />
      )}
    </td>
  );
};

export default StudentGradeCell;
